import React, { Component } from "react";
import { Grid, Box, CardContent, CardMedia } from "@mui/material";
import CtTxt from "./CustomTool/CtTxt";
import CtDtp from "./CustomTool/CtDtp";
import CtTxtAmt from "./CustomTool/CtTxtAmt";
import CtTxtNum from "./CustomTool/CtTxtNum";
import CtCmb from "./CustomTool/CtCmb";
import TextAreaAutoSize from "./CustomTool/TextAreaAutoSize";
import CtBtn from "./CustomTool/CtBtn";
import { Edit, Delete, ThirtyFpsSharp } from "@mui/icons-material";
import CtMultiLineText from "./CustomTool/CtMultiLineText";
import { withRouter } from "../HOC/withRouter";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import AlertResponsiveDialog from "./CustomTool/AlertResponsiveDialog";
import { connect } from "react-redux";
import Progress from "./CustomTool/Progress";
import {
  mapStatetoProps,
  mapSetActiveMenuToProps,
  mapSetActiveMenu_MenuVisibility_ToProps,
} from "../mapRedux/mapReduxProps";
import {
  fetchLoadUnload,
  fetchDriverTripRateDetail,
  fetchPlaceDetail,
} from "./API";
import {
  get_YMD_from_SYS,
  get_30DaysBack_FromCurrentDate,
  isValidItem,
  getlocalstoragedate,
  setlocalstoragedate,
  applyTrimOnObjectValues,
  csvFileName,
} from "../SystemUtility/SystemUtility";
import TableList from "./CustomTool/TableList";
import VehicleUnload from "./VehicleUnload";
import CtCmbEditable from "./CustomTool/CtCmbEditable";
import ResetDate from "../images/resetdate.png";
import MaterialTable from "./CustomTool/MaterialTable";
import CustomerMaster from "./CustomerMaster";
import LedgerMaster from "./LedgerMaster";
import TripItemEntry from "./TripItemEntry";
import PlaceMaster from "./PlaceMaster";
import CtART from "./CustomTool/ResponsiveTable";

class DriverMaster extends Component {
  state = {
    Place: [],
    formData: {
      bint_srno: "",
      txtNoWheels: "",
      txtRate: "",
      cmbDestination: "",
    },

    columnsdata: [
      {
        accessorKey: "bint_srno",
        header: "Sr No.",
      },
      {
        accessorKey: "int_noofwheels",
        header: "No. Wheels",
      },
      {
        accessorKey: "vac_destination",
        header: "Destination",
      },
      {
        accessorKey: "dec_triprate",
        header: "Driver Trip Rate",
      },
    ],
    rows: [],

    rowsCount: 0,
    rowsPerPage: 50,
    counter: 0,

    dataLoadStatus: true,
    ARD: null,
  };

  //#region Component
  componentDidMount() {
    document.title = "RiTe Account : Driver Trip Rate Master";
    this.props.setActiveMenu("DriverTripRateMaster");
    this.props.verifyUserID(
      this.onFormLoad,
      this.props.navInfo.subMenuMaster,
      this.props.setSubMenu_Master_Entry,
      this.props.setUserPrivileges
    );
  }

  handleOnChange = (e) => {
    this.setState({
      formData: { ...this.state.formData, [e.target.name]: e.target.value },
    });
  };

  handleChangeRowsPerPageOtherDetail = (rowsPerPageOtherDetail) => {
    this.setState({ rowsPerPageOtherDetail });
  };

  handleOnNewEntryClick = () => {
    let ARD = null;
    this.setState({ ARD }, () => {
      ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          // New : Sales Item Entry'
          maxWidthClass={"xl"}
          alertMessage={<TripItemEntry />}
          defaultOpenDialog={true}
          onYesClickCloseIfExeSuccessfully={true}
        />
      );
      this.setState({ ARD });
    });
  };

  handleChangeRowsPerPage = (rowsPerPage) => {
    this.setState({ rowsPerPage });
  };

  handleOnRowDataChange = (rows, handledRowIndex, colID) => {
    this.setState({ rows, rowsCount: rows.length }, () => {});
  };

  trimFormData = (nextFunctionCall) => {
    let formData = applyTrimOnObjectValues({
      formData: this.state.formData,
      // excludeKeysArray: [""],
    });
    this.setState({ formData }, () => {
      if (nextFunctionCall) {
        nextFunctionCall();
      }
    });
  };

  onClickPlaceMaster = () => {
    this.setState({ ARD: null }, () => {
      let ARD = (
        <AlertResponsiveDialog
          labelDisagree="Close"
          maxWidthClass={"xl"}
          alertMessage={<PlaceMaster />}
          defaultOpenDialog={true}
          handleOnClickNo={() => {
            this.getPlaceList();
            document.title = "RiTe Account : Driver Trip Rate Master";
            this.props.setActiveMenu("DriverTripRateMaster");
          }}
        />
      );
      this.setState({ ARD });
    });
  };

  getPlaceList = () => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "LoadPlace",
      bint_acid: localStorage.getItem("acid"),
    };
    fetchPlaceDetail(reqData)
      .then((res) => {
        this.props.updateProcessing("success", "Place List Loaded");
        let Place = res.data.PlaceList;
        this.setState(
          {
            Place,
          },
          () => {
            // console.log("this.state", this.state);
          }
        );
      })
      .catch((error) => {
        console.log("Unknown error occurred in getPlace.", error);
      });
  };

  onFormLoad = () => {
    let dataLoadStatus = false;
    this.setState({ dataLoadStatus }, () => {
      const reqData = {
        Op: "LoadDriverTripRate",
        bint_acid: localStorage.getItem("acid"),
      };
      fetchDriverTripRateDetail(reqData)
        .then((res) => {
          dataLoadStatus = true;
          let rows = [],
            Place = [],
            rowsCount = 0;
          if (
            res.data.DriverTripRateList &&
            res.data.DriverTripRateList.length > 0
          ) {
            rows = res.data.DriverTripRateList;
            rowsCount = rows.length;
          }
          if (res.data.PlaceList && res.data.PlaceList.length > 0) {
            Place = res.data.PlaceList;
          }
          this.setState({
            dataLoadStatus,
            rows,
            Place,
            rowsCount,
          });
        })
        .catch((error) => {
          console.log("Unknown error occurred in onFormLoad.", error);
        });
    });
    document.getElementById("txtNoWheels").focus();
  };

  clearInfo = () => {
    let bint_srno = "",
      txtNoWheels = "",
      txtRate = "",
      cmbDestination = "";

    this.setState(
      {
        formData: {
          ...this.state.formData,
          bint_srno,
          txtNoWheels,
          txtRate,
          cmbDestination,
        },
      },
      () => {
        document.getElementById("txtNoWheels").focus();
      }
    );
  };

  validatDriverTripRateMaster = () => {
    const { txtNoWheels, txtRate, cmbDestination } = this.state.formData;

    if (txtNoWheels === "" || Number(txtNoWheels) == 0) {
      this.props.toastErrorMsg("Enter No. Wheels", "txtNoWheels");
      return false;
    } else if (txtRate === "" || Number(txtRate) == 0) {
      this.props.toastErrorMsg("Enter Rate", "txtRate");
      return false;
    } else if (cmbDestination === "") {
      this.props.toastErrorMsg("Enter Destination", "cmbDestination");
      return false;
    }
    return true;
  };

  handleARDonActionClick_Edit = (row) => {
    console.log("row", row);
    // console.log('row.original["bint_srno"]', row.original["bint_srno"]);
    const bint_srno = row.getValue("bint_srno"),
      txtNoWheels = row.getValue("int_noofwheels"),
      cmbDestination = row.getValue("vac_destination"),
      txtRate = row.getValue("dec_triprate");
    // const rows2 = row.original.CheckToDoList;
    // console.log("rows2", rows2);
    this.setState({
      formData: {
        ...this.state.formData,
        bint_srno,
        txtNoWheels,
        cmbDestination,
        txtRate,
      },
    });
    window.scrollTo(0, 0);
    document.getElementById("txtNoWheels").focus();
  };

  SaveDriverTripRate = () => {
    this.trimFormData(() => {
      if (this.validatDriverTripRateMaster()) {
        let dataLoadStatus = false;
        this.props.notifyProcessing();
        this.setState({ dataLoadStatus: false }, () => {
          const reqData = {
            Op: "SaveDriverTripRate",
            bint_acid: localStorage.getItem("acid"),
            bint_srno: this.state.formData.bint_srno,
            int_noofwheels: this.state.formData.txtNoWheels,
            vac_destination: this.state.formData.cmbDestination,
            dec_triprate: this.state.formData.txtRate,
          };
          fetchDriverTripRateDetail(reqData)
            .then((res) => {
              this.props.updateProcessing(res.data.msgType, res.data.message);
              let dataLoadStatus = true,
                rows = this.state.rows,
                rowsCount = rows.length;
              if (res.data.msgType === "success") {
                if (
                  res.data.DriverTripRateList &&
                  res.data.DriverTripRateList.length > 0
                ) {
                  rows = res.data.DriverTripRateList;
                  rowsCount = rows.length;
                }
              }
              this.setState(
                {
                  dataLoadStatus,
                  rows,
                  rowsCount,
                },
                () => {
                  if (res.data.msgType === "success") {
                    this.clearInfo();
                  }
                }
              );
            })
            .catch((error) => {
              console.log(
                "Unknown error occurred in SaveDriverTripRateMaster.",
                error
              );
            });
        });
      }
    });
  };

  handleARDonActionClick_Delete = (row) => {
    const bint_srno = row.getValue("bint_srno"),
      DriverTripRate = row.getValue("int_noofwheels");
    // Destination = row.getValuem("cmbDestination"),
    // Rate = row.getValue("dec_triprate");
    // this.DeleteData(bint_srno, DriverTripRate, Destination, Rate);
    this.DeleteData(bint_srno, DriverTripRate);
  };

  DeleteData = (bint_srno, DriverTripRate, Destination) => {
    if (bint_srno > 0) {
      this.setState({ ARD: null }, () => {
        let ARD = (
          <AlertResponsiveDialog
            labelAgree="Delete"
            labelDisagree="Cancel"
            alertTitle={
              "Do you want to Delete Driver Trip Rate : " +
              DriverTripRate +
              " ?"
            }
            alertMessage=""
            handleOnClickYes={() => {
              return this.DeleteDriverTripRate(bint_srno);
            }}
            defaultOpenDialog={true}
            onYesClickCloseIfExeSuccessfully={true}
          />
        );

        this.setState({ ARD });
      });
    } else {
      this.props.toastErrorMsg("Select a record for deletion.");
    }
  };

  DeleteDriverTripRate = (bint_srno) => {
    this.props.notifyProcessing();
    const reqData = {
      Op: "DeleteDriverTripRate",
      bint_acid: localStorage.getItem("acid"),
      bint_srno: bint_srno,
      // bol_list: true,
    };
    fetchDriverTripRateDetail(reqData)
      .then((res) => {
        this.props.updateProcessing(res.data.msgType, res.data.message);
        if (res.data.msgType === "success") {
          let rows = [],
            rowsCount = rows.length;
          if (
            res.data.DriverTripRateList &&
            res.data.DriverTripRateList.length > 0
          ) {
            rows = res.data.DriverTripRateList;
            rowsCount = rows.length;
          }
          this.setState(
            {
              rows,
              rowsCount,
              ARD: null,
            },
            () => {
              this.onFormLoad();
              this.clearInfo();
            }
          );
          document.getElementById("txtNoWheels").focus();
        }
      })

      .catch((error) => {
        this.props.updateProcessing(
          "error",
          "Unknown error occurred in delete Check list. " + error
        );
      });
    return false;
  };

  render() {
    return (
      <form>
        <Progress
          color="primary"
          display={this.state.dataLoadStatus !== true}
        />
        {/* <Grid
          container
          direction="row"
          justifyContent="center"
          alignItems="center"
          className="title"
        >
          <label htmlFor="Title" style={{ fontSize: "25px", color: "#6f7689" }}>
            <b>Driver Trip Rate Master</b>
          </label>
        </Grid> */}
        <Grid
          container
          direction="column"
          spacing={2}
          // marginTop={0}
          justifyContent="center"
          alignItems="center"
        >
          <Grid item>
            <Grid
              container
              direction="row"
              spacing={2}
              justifyContent="flex-start"
              alignItems="center"
              // marginTop={0}
            >
              <Grid item>
                <CtTxtNum
                  id="txtNoWheels"
                  value={this.state.formData.txtNoWheels}
                  handleOnChange={this.handleOnChange}
                  label="No. Wheels*"
                  width={120}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"txtRate"}
                />
              </Grid>
              <Grid item>
                <CtTxtAmt
                  id="txtRate"
                  value={this.state.formData.txtRate}
                  handleOnChange={this.handleOnChange}
                  label="Rate*"
                  width={115}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  nextCtrlID={"cmbDestination"}
                />
              </Grid>
            </Grid>

            <Grid
              container
              direction="row"
              spacing={2}
              justifyContent="flex-start"
              alignItems="center"
              marginTop={0}
            >
              <Grid item>
                <CtCmbEditable
                  id="cmbDestination"
                  label="Destination*"
                  items={this.state.Place}
                  value={this.state.formData.cmbDestination}
                  handleOnChange={this.handleOnChange}
                  bolVisibleOnAddClickIcon={
                    this.props.userPrivilege.Customer == "A" ? true : false
                  }
                  onAddClick={this.onClickPlaceMaster}
                  width={250}
                  maxLength={100}
                  onKeyDown={this.props.onKeyDown}
                  colID="vac_placename"
                  defaultAction={this.SaveDriverTripRate}
                />
              </Grid>
            </Grid>
            <Grid
              container
              direction="row"
              spacing={2}
              // justifyContent="center"
              alignItems="flex-start"
              marginTop={1}
            >
              <Grid item>
                <CtBtn label="Save" onClick={this.SaveDriverTripRate} />
              </Grid>

              <Grid item>
                <CtBtn
                  label="New"
                  onClick={this.clearInfo}
                  variant={"outlined"}
                />
              </Grid>
              <Grid item>
                <CtBtn
                  label="Delete"
                  onClick={() => {
                    this.DeleteData(
                      this.state.formData.bint_srno,
                      this.state.formData.txtNoWheels,
                      this.state.formData.cmbDestination,
                      this.state.formData.txtRate
                    );
                  }}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <br />

        <Grid item marginTop={3} className="maintable">
          {/* <MaterialTable
            rowsdata={this.state.rows}
            columnsdata={this.state.columns}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            onEditAction={this.handleARDonActionClick_Edit}
            onDeleteAction={this.handleARDonActionClick_Delete}
            showColumnFilters={false}
            hideColIdList={["bint_srno"]}
            actionColSize={25}
            density={"compact"}
          /> */}

          <CtART
            rowsdata={this.state.rows}
            columnsdata={this.state.columnsdata}
            rowsPerPage={this.state.rowsPerPage}
            tblmaxHeight={500}
            csvFileName={csvFileName("DriverTripRate")}
            rowIconAction={[
              {
                label: "Edit",
                onClick: this.handleARDonActionClick_Edit,
                icon: "Edit",
                className: "secondary-button",
              },
              {
                label: "Delete",
                onClick: this.handleARDonActionClick_Delete,
                icon: "delete",
                className: "delete-button",
              },
            ]}
            showColumnFilters={false}
            actionColSize={20}
            hideColIdList={["bint_srno"]}
            density={"compact"}
          />
        </Grid>
        <Grid item>
          <Box display={{ xs: "none" }} style={{ textAlign: "right" }}>
            {this.state.ARD}
          </Box>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(DriverMaster))));
